import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=3481273c&scoped=true"
import script from "./DefaultView.vue?vue&type=script&lang=js"
export * from "./DefaultView.vue?vue&type=script&lang=js"
import style0 from "./DefaultView.vue?vue&type=style&index=0&id=3481273c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481273c",
  null
  
)

export default component.exports